import React from 'react'
import { MovableModalContainer } from 'components/MovableModal'
import { useSelector } from 'react-redux'
import { selectShowEditorSettings } from 'selectors/mainView'
import { EditorSettingsComponent } from './EditorSettingsComponent'

export const EditorSettingsContainer = () => {
  const visible = useSelector(selectShowEditorSettings)
  return (
    <MovableModalContainer
      visible={visible}
      width={750}
      height={600}
      withBackground
      pointerEvents={false}
      windowId="EditorSettingsContainer"
    >
      <EditorSettingsComponent />
    </MovableModalContainer>
  )
}
